module.exports = __webpack_public_path__ + "img/dynamic-10.277df78d.png";